import { mdiMessageOutline } from '@mdi/js'

export default {
  title: 'Forum',
  to: 'forum-list',
  icon: mdiMessageOutline,
  resource: 'Forum',
  action: 'read',
}
